/**
 * Copyright 2018 Ambrosus Inc.
 * Email: tech@ambrosus.com
 */
import React, { Component } from 'react';
import './Header.scss';
import { NavLink, withRouter } from 'react-router-dom';
import SVG from 'react-svg';
import iconLogo from 'src/assets/svg/amb.svg';
import sdkLogo from 'src/assets/svg/SDK.svg';
import { Sidemenu } from '@ambrosus/react';
import Navigation from '../Navigation';

class Header extends Component<any, any> {
  public state: any = {
    account: {},
    hideHeader: false,
  };

  private _class = '';

  public componentDidMount() {
    this.routeChanged();
  }

  public componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      this.routeChanged();
    }
  }

  private routeChanged() {
    this._class = location.pathname === '/' ? 'home' : location.pathname.split('/')[1];
    document.body.className = '';
    document.body.classList.add(this._class);
    document.body.classList.add('page-loaded');
  }

  public getSideNav() {
    if ( window.location.href.indexOf('documentation') === -1 ) {
      return 'none';
    }
    return '';
  }

  public render() {
    const { hideStatus, hideHeader } = this.state;
    return (
      !hideHeader &&
      (<header className={`Header${hideStatus ? ' header-hide' : ''}`}>
        <div className='wrapper'>
          <div style={{ display: this.getSideNav() }} className='side-menu'>
            <Sidemenu>
              <Navigation />
            </Sidemenu>
          </div>
          <NavLink className='logo' to={'/'}>
            <SVG className='SVG' wrapper='span' src={iconLogo} />
            <SVG style={{ paddingLeft: '10px' }} className='SVG' wrapper='span' src={sdkLogo} />
          </NavLink>
          <nav className='menu'>
            <ul>
              <li>
                <NavLink exact activeClassName='active' to='/documentation'>Documentation</NavLink>
              </li>
              <li>
                <NavLink exact activeClassName='active' to='/'>SDKs & Tools</NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </header>)
    );
  }
}

export default withRouter(Header);
